/**
 * Checks whether the given instance has errored.
 * @param  {Instance}  instance
 * @returns {boolean}
 */
function hasErrorReduxUtil (instance) {
  if (!instance) {
    return false
  }
  return !!instance.error
}

export {
  hasErrorReduxUtil
}
